import { NgModule } from '@angular/core';
import { DirectivesModule } from './directives/directives.module';
import { PipesModule } from './pipes/pipes.module';
import { DialogComponent } from './dialog/dialog.component';
import { CommonModule } from '@angular/common';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ClearComponent } from './clear/clear.component';
import { CheckComponent } from './check/check.component';
import { OTPComponent } from './otp/otp.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentComponent } from './payment/payment.component';
import { LoadingComponent } from './loading/loading.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';
import { MaskPipe } from 'src/app/shared/pipes/mask.pipe';

@NgModule({
  declarations: [
    DialogComponent,
    ClearComponent,
    CheckComponent,
    OTPComponent,
    PaymentComponent,
    LoadingComponent,
  ],
  imports: [
    MatProgressSpinnerModule,
    OverlayModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModalModule,
    CommonModule,
    PipesModule,
    DirectivesModule,
  ],
  exports: [
    DialogComponent,
    ClearComponent,
    CheckComponent,
    LoadingComponent,
    MaskPipe
  ]
})
export class SharedModule { }
